"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var services_1 = require("../../services");
require("../../styles/cidades.css");
var UseIbgeState = function (_a) {
    var id = _a.id;
    var _b = (0, react_1.useState)(null), estado_ibge = _b[0], setEstado_ibge = _b[1];
    var _c = (0, react_1.useState)([]), cidades_ibge = _c[0], setCidades_ibge = _c[1];
    var _d = (0, react_1.useState)(""), searchText = _d[0], setSearchText = _d[1];
    (0, react_1.useEffect)(function () { (0, services_1.get_estado)(id).then(setEstado_ibge); }, [id]);
    (0, react_1.useEffect)(function () { handleFilter(); }, [estado_ibge]);
    var handleFilter = function (withText) {
        var _a;
        if (withText === void 0) { withText = false; }
        var cidades = (_a = estado_ibge === null || estado_ibge === void 0 ? void 0 : estado_ibge.cidades) !== null && _a !== void 0 ? _a : [];
        if (withText == false)
            return setCidades_ibge(cidades);
        var text = searchText;
        var sanitized_value = text.toLowerCase().trim();
        var resultado = cidades.filter(function (x) { return x.nome.toLowerCase().includes(sanitized_value); });
        return setCidades_ibge(resultado);
    };
    return {
        estado_ibge: estado_ibge,
        cidades_ibge: cidades_ibge,
        searchText: searchText,
        setSearchText: setSearchText,
        handleFilter: handleFilter
    };
};
var CidadesPage = function (_a) {
    var id = _a.id, onEnd = _a.onEnd, current_state = _a.current_state;
    var _b = (0, react_1.useState)([]), selectedList = _b[0], setSelectedList = _b[1]; // Cidades selecionadas
    var _c = UseIbgeState({ id: id }), cidades_ibge = _c.cidades_ibge, estado_ibge = _c.estado_ibge, searchText = _c.searchText, setSearchText = _c.setSearchText, handleFilter = _c.handleFilter;
    (0, react_1.useEffect)(function () {
        var indexOf = current_state.findIndex(function (v) { return v.id === id; });
        if (indexOf === -1)
            return;
        var estado = current_state[indexOf];
        return setSelectedList(estado.cidades);
    }, [current_state]);
    var handleClick = function (id) {
        setSelectedList(function (prev) {
            if (id == -1) {
                if (selectedList.length === cidades_ibge.length)
                    return [];
                var all_selected = cidades_ibge.map(function (c) { return c.id; });
                return all_selected;
            }
            var prevData = __spreadArray([], prev, true);
            var sliced = prevData.filter(function (c) { return c != id; });
            prevData = sliced.length < prevData.length ? sliced : __spreadArray(__spreadArray([], prevData, true), [id], false);
            return (prevData);
        });
    };
    if ((estado_ibge === null || estado_ibge === void 0 ? void 0 : estado_ibge.cidades.length) == 0)
        return (0, jsx_runtime_1.jsx)("span", { children: " \"Loading...\" " }, void 0);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'cidade-page-container' }, { children: [(0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return onEnd(); } }, { children: " Voltar " }), void 0), (0, jsx_runtime_1.jsx)("span", { children: estado_ibge === null || estado_ibge === void 0 ? void 0 : estado_ibge.nome }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "cidade-page-container-search-bar" }, { children: [(0, jsx_runtime_1.jsx)("input", { value: searchText, onInput: function (e) { return setSearchText(e.target.value); } }, void 0), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return handleFilter(true); } }, { children: " pesquisar " }), void 0)] }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: 'city-check-box', onClick: function () { return handleClick(-1); } }, { children: [(0, jsx_runtime_1.jsx)("input", { readOnly: true, value: -1, type: "checkbox", checked: selectedList.length == cidades_ibge.length }, void 0), (0, jsx_runtime_1.jsx)("label", { children: "Todos" }, void 0)] }), -1), cidades_ibge.map(function (c) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'city-check-box', onClick: function () { return handleClick(c.id); } }, { children: [(0, jsx_runtime_1.jsx)("input", { readOnly: true, value: c.id, type: "checkbox", checked: selectedList.includes(c.id) }, void 0), (0, jsx_runtime_1.jsx)("label", { children: c.nome }, void 0)] }), c.id)); })] }, void 0), (0, jsx_runtime_1.jsxs)("section", { children: [(0, jsx_runtime_1.jsxs)("span", { children: [" Total Selecionado: ", selectedList.length, "/", cidades_ibge.length] }, void 0), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { return onEnd(selectedList); } }, { children: " Ok" }), void 0)] }, void 0)] }), void 0));
};
exports.default = CidadesPage;
//# sourceMappingURL=index.js.map